<header id="header" class="min-w-full bg-white shadow-custom md:hidden" *transloco="let t">
  <lm-page-header pageTitle="menu" [elevated]="false" *viewportSize="'mobile'"></lm-page-header>
  <div class="flex justify-start py-3.5 px-6 gap-x-2 items-center">
    <!-- <img class="w-5 h-auto search-icon mr-3.5 mb-0.5" src="../../../assets/Search.svg" /> -->
    <fa-icon [icon]="faSearch"></fa-icon>
    <input type="text" placeholder="{{ t('find') }}" class="uppercase text-xs focus-visible:outline-none w-full" />
  </div>
</header>
<main class="p-5 pt-20 md:hidden" *transloco="let t">
  <div class="pb-20">
    <div class="grid grid-cols-3 gap-x-3.5 gap-y-7 mt-4.5">
      <div
        *ngFor="let item of menuItems"
        class="w-full flex flex-col justify-center items-center min-h-[102px] border border-green-active border-opacity-50 rounded-[10px] aspect-square gap-y-1 active:border-black active:bg-[#9AD0D0]"
        [routerLink]="item.url"
      >
        <div *ngIf="item.action">
          <img *ngIf="item.icon" [src]="item.icon" color="light" class="invert w-[35px]" (click)="manageAction(item.action)" />
        </div>
        <div *ngIf="!item.action">
          <img *ngIf="item.icon" [src]="item.icon" color="light" class="invert w-[35px]" />
        </div>
        <h3 class="uppercase text-xs mt-1 font-medium text-center w-full px-2">{{ t(item.label) }}</h3>
      </div>
    </div>
  </div>
</main>
